module.exports = __webpack_public_path__ + "img/img-7.47095aa5.png";